import { action, createRequestTypes } from '../base';

export const maskingPolicyActionTypes = {
  CREATE_MASKING_POLICY: createRequestTypes('CREATE_MASKING_POLICY'),
  GET_MASKING_POLICY_BY_ID: createRequestTypes('GET_MASKING_POLICY_BY_ID'),
  GET_MASKING_POLICIES: createRequestTypes('GET_MASKING_POLICIES'),
  UPDATE_MASKING_POLICY: createRequestTypes('UPDATE_MASKING_POLICY'),
  DELETE_MASKING_POLICY: createRequestTypes('DELETE_MASKING_POLICY'),
  MASKING_POLICY_EDIT_PAGE: createRequestTypes('MASKING_POLICY_EDIT_PAGE'),
};

/**
 *
 */
class MaskingPolicyActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createMaskingPolicy = (payload, callback) => action(maskingPolicyActionTypes.CREATE_MASKING_POLICY.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param createMaskingPolicyLoading
   * @return {{type: *}}
   */
   createMaskingPolicyLoading = (createMaskingPolicyLoading) => action(maskingPolicyActionTypes.CREATE_MASKING_POLICY.LOADING, {
     createMaskingPolicyLoading,
   })

   /**
    *
    * @param createMaskingPolicy
    * @return {{type: *}}
    */
   createMaskingPolicySuccess = (createMaskingPolicy) => action(maskingPolicyActionTypes.CREATE_MASKING_POLICY.SUCCESS, {
     createMaskingPolicy,
   })

  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param maskingPolicyId
   * @param callback
   * @return {{type: *}}
   */
  getMaskingPolicies = (orgId, maskingPolicyId, page, limit, callback) => action(maskingPolicyActionTypes.GET_MASKING_POLICIES.REQUEST, {
    orgId,
    maskingPolicyId,
    page,
    limit,
    callback,
  });

  /**
   *
   * @param getMaskingPoliciesLoading
   * @return {{type: *}}
   */
  getMaskingPoliciesLoading = (getMaskingPoliciesLoading) => action(maskingPolicyActionTypes.GET_MASKING_POLICIES.LOADING, {
    getMaskingPoliciesLoading,
  })

  /**
   *
   * @param maskingPolicies
   * @return {{type: *}}
   */
  getMaskingPoliciesSuccess = (maskingPolicies) => action(maskingPolicyActionTypes.GET_MASKING_POLICIES.SUCCESS, {
    maskingPolicies,
  })

  /**
   * @param maskingPolicyId
   * @return {{type: *}}
   */
  getMaskingPolicyById = (orgId, maskingPolicyId, callback) => action(maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.REQUEST, {
    orgId,
    maskingPolicyId,
    callback,
  })

  /**
   *
   * @param getMaskingPolicyByIdLoading
   * @return {{type: *}}
   */
  getMaskingPolicyByIdLoading = (getMaskingPolicyByIdLoading) => action(maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.LOADING, {
    getMaskingPolicyByIdLoading,
  });

  /**
   *
   * @param selectedMaskingPolicy
   * @return {{type: *}}
   */
   getMaskingPolicyByIdSuccess = (selectedMaskingPolicy) => action(maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.SUCCESS, {
     selectedMaskingPolicy,
   });

  /**
   * @param payload
   * @param callback
   * @param history
   * @return {{type: *}}
   */
  updateMaskingPolicy = (payload, callback) => action(maskingPolicyActionTypes.UPDATE_MASKING_POLICY.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param updateMaskingPolicyLoading
   * @return {{type: *}}
   */
   updateMaskingPolicyLoading = (updateMaskingPolicyLoading) => action(maskingPolicyActionTypes.UPDATE_MASKING_POLICY.LOADING, {
     updateMaskingPolicyLoading,
   })

   /**
    *
    * @param updateMaskingPolicy
    * @return {{type: *}}
    */
   updateMaskingPolicySuccess = (updateMaskingPolicy) => action(maskingPolicyActionTypes.UPDATE_MASKING_POLICY.SUCCESS, {
     updateMaskingPolicy,
   })

   /**
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
      deleteMaskingPolicy = (payload, callback) => action(maskingPolicyActionTypes.DELETE_MASKING_POLICY.REQUEST, {
        payload, callback,
      })

      /**
       * @param updateSOStatusLoading
       * @param deleteMaskingPolicyLoading
       * @return {{type: *}}
       */
       deleteMaskingPolicyLoading = (deleteMaskingPolicyLoading) => action(maskingPolicyActionTypes.DELETE_MASKING_POLICY.LOADING, {
         deleteMaskingPolicyLoading,
       })

       /**
   * @return {{type: *}}
   */
     getMaskingPolicyEditPage = () => action(maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.REQUEST, {
     });

    /**
     *
     * @param getMaskingPolicyEditPageLoading
     * @return {{type: *}}
     */
    getMaskingPolicyEditPageLoading = (getMaskingPolicyEditPageLoading) => action(maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.LOADING, {
      getMaskingPolicyEditPageLoading,
    })

    /**
     *
     * @param maskingPolicyEditPage
     * @return {{type: *}}
     */
     getMaskingPolicyEditPageSuccess = (maskingPolicyEditPage) => action(maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.SUCCESS, {
       maskingPolicyEditPage,
     })
}
export default new MaskingPolicyActions();
